import { Fragment } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { IonItem, IonLabel, IonList, IonText } from "@ionic/react";
import { TimetableType } from "../../hooks/useTimetablePeriods";
import { SelectedCoverTeacher } from "./CoverTeacherSelect";
import {
  OnCallTeacher,
  useOnCallTeachers,
} from "../../hooks/useOnCallTeachers";
import ContactProfileImage from "./ContactProfileImage";
import DateMini from "./DateMini";

import "./OnCallsSelector.css";

interface ContainerProps extends RouteComponentProps<any> {
  timetableType: TimetableType;
  timetableDate: string;
  timetablePeriod: string | null;
  onSelected: (teacher: OnCallTeacher) => void;
  coverTeachers: SelectedCoverTeacher[];
  heading?: string;
}

// eslint-disable-next-line react-refresh/only-export-components
const OnCallsSelector: React.FC<ContainerProps> = ({
  timetableType,
  timetableDate,
  timetablePeriod,
  onSelected,
  coverTeachers,
  heading,
}) => {
  const { myOnCallTeachers } = useOnCallTeachers(
    timetableDate,
    timetableType,
    timetablePeriod ?? ""
  );

  const handleTeacherSelected = (teacher: OnCallTeacher) => {
    onSelected(teacher);
  };

  return (
    <Fragment>
      <IonList className="oncalls-selector">
        <IonItem lines="none" className="oncalls-header">
          {heading && <IonText>
            <h3>{heading}</h3>
          </IonText>}
          <IonText slot="end">Last Cover</IonText>
        </IonItem>
        {myOnCallTeachers && myOnCallTeachers.length > 0
          ? myOnCallTeachers.map((teacher: OnCallTeacher, idx: number) => {
            if (coverTeachers.some((ct) => ct._id === teacher._id)) {
              return null;
            } else {
              return (
                <IonItem
                  key={teacher.id + timetableDate + timetablePeriod + idx}
                  onClick={() => handleTeacherSelected(teacher)}
                  className="oncalls-teacher"
                >
                  <div slot="start">
                    <ContactProfileImage
                      cssClass="list-profile-image"
                      profile={{ contactId: teacher?._id }}
                      onSelect={() => {
                        console.log("disabled.");
                      }}
                    />
                  </div>
                  <IonLabel>
                    {teacher.Name}
                    <IonText>
                      <i>{teacher?.Department}</i>
                    </IonText>
                  </IonLabel>

                  {teacher?.LastCoverDate && (
                    <div slot="end">
                      <DateMini date={teacher?.LastCoverDate} />
                    </div>
                  )}
                </IonItem>
              );
            }
          })
          : null}
      </IonList>
    </Fragment>
  );
};

export default withRouter(OnCallsSelector);
